import { useEffect, useState } from "react";
import { isTracking, getTrackDistance } from "@/lib/backgroundTracker";

/**
 * ActiveTrackBanner — full-width green/blue strip at top of Mileage screen.
 * Visible on ALL tabs when auto-tracking is active.
 * Shows pulsing dot + "Auto-Track Active" + elapsed distance.
 * Tapping it calls onTap (switches to Trips tab).
 */
export default function ActiveTrackBanner({ onTap }) {
  const [active, setActive] = useState(false);
  const [distance, setDistance] = useState(0);

  useEffect(() => {
    // Poll every 2s to update tracking state
    const check = () => {
      const tracking = isTracking();
      setActive(tracking);
      if (tracking) {
        setDistance(getTrackDistance());
      }
    };
    check();
    const id = setInterval(check, 2000);
    return () => clearInterval(id);
  }, []);

  if (!active) return null;

  return (
    <button
      onClick={onTap}
      className="w-full flex items-center justify-between px-4 py-2.5 bg-gradient-to-r from-[#34C759]/20 to-[#007AFF]/20 border border-[#34C759]/30"
      style={{ touchAction: "manipulation" }}
      data-testid="active-track-banner"
    >
      <div className="flex items-center gap-2">
        {/* Pulsing dot */}
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#34C759] opacity-75" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#34C759]" />
        </span>
        <span className="text-sm font-medium text-[#34C759] tracking-wide">Auto-Track Active</span>
      </div>
      <span className="text-sm text-zinc-300 font-mono tabular-nums">
        {distance.toFixed(1)} mi so far
      </span>
    </button>
  );
}
